import { useState, useEffect } from 'react'

const useContent = (contentFile) => {
  const [content, setContent] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const loadContent = async () => {
      try {
        setLoading(true)
        // Laad JSON bestanden uit de public folder
        const response = await fetch(`/content/${contentFile}.json`)
        
        if (!response.ok) {
          throw new Error(`Failed to load content: ${response.statusText}`)
        }
        
        const data = await response.json()
        setContent(data)
        setError(null)
      } catch (err) {
        console.error('Error loading content:', err)
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    loadContent()
  }, [contentFile])

  return { content, loading, error }
}

export default useContent
